<!-- Begin WebApp tabs -->
<ng-container *ngIf="initialized">


<div soho-tabs
    class="is-personalizable"
    headerTabs="true"
    [disableAutoUpdatedCall]="false"
    (afterActivated)="onTabActivated($event)">

  <div soho-tab-list-container id="header-tabs">
    <ul soho-tab-list *ngIf="displayDataGrid">
      <li soho-tab>
        <a soho-tab-title tabId="{{TAB_ID_ALLREPORTS}}" data-automation-id="lm-reports-catalog-allreports-tab">{{catalogTabTitle}}</a>
      </li>
      <li soho-tab *ngIf="printFilesEnabled">
        <a soho-tab-title tabId="{{TAB_ID_PRINTFILES}}" data-automation-id="lm-reports-catalog-printfiles-tab">{{printFilesTabTitle}}</a>
      </li>
    </ul>
  </div>
</div>

<div soho-tab-panel-container
    soho-busyindicator
    [blockUI]="true"
    displayDelay="100"
    class="lm-reports-catalog-wrapper"
    id="lm-reports-catalog-wrapper">

  <div soho-tab-panel *ngIf="displayDataGrid"
      tabId="{{TAB_ID_ALLREPORTS}}"
      id="{{TAB_ID_ALLREPORTS}}"
      class="scrollable">
    <lm-reports-list
        [reportsArray]="reportsArray"
        [categoriesByModule]="categoriesByModule"
        reportListId="all-list"
        (reportListEvent)="onReportListEvent($event)"
    ></lm-reports-list>
  </div>

  <div soho-tab-panel *ngIf="displayDataGrid && printFilesEnabled"
      tabId="{{TAB_ID_PRINTFILES}}"
      id="{{TAB_ID_PRINTFILES}}"
      class="scrollable">
    <lm-list *ngIf="!doRetrievePrintFilesSpec && printFilesListUrlInfo"
        [listUrlInfo]="printFilesListUrlInfo"
        [listSpec]="printFilesListSpec"
        [hasDependentData]="false"
        [listInPagePaneTab]="true"
        [pageHasContextForm]="false"
        [pageHasTabs]="true"
        (sendContextMessageEvent)="onSendContextMessageEvent($event)"
    ></lm-list>
  </div>
</div>

<div #modalPlaceholder id="modalPlaceholder"></div>
</ng-container>